// Placeholder Monday Brief data — mixed across trades.
export const sampleBusiness = {
  name: "Ridgeline Plumbing Co.",
  ownerFirstName: "Sam",
  trade: "Plumbing",
  city: "Boise, ID",
};

export const briefMeta = {
  weekOf: "Monday, February 24, 2026",
  greeting: "Here's what we saw last week, Sam.",
  intro:
    "Two wins to celebrate from last week, and a couple of small nudges to make this week even better.",
};

export const briefCards = [
  {
    id: "reviews",
    tone: "positive",
    icon: "star",
    tag: "Reputation",
    trade: "Plumbing",
    title: "You picked up 4 new 5-star reviews last week",
    happened:
      "Four of your customers left glowing Google reviews between Tuesday and Friday — two mentioned Danny by name.",
    whyMatters:
      "Fresh 5-star reviews are the single biggest reason a new neighbor picks you over the shop down the street. Google shows the most recent ones first.",
    recommendation:
      "Send a short thank-you text to each customer who left one. It usually earns you a repeat call within 90 days.",
    impact:
      "Businesses in your area who reply to reviews within 48 hours see roughly 12% more calls the following month.",
  },
  {
    id: "gbp",
    tone: "action",
    icon: "map",
    tag: "Local Search",
    trade: "HVAC",
    title: "Your Google profile is missing summer hours",
    happened:
      "Homeowners searching “AC repair near me” this week were shown your winter hours. Summer is 6 weeks out and searches are already climbing 22% locally.",
    whyMatters:
      "When your hours look off, folks scroll to the next company — even if you're open. It's the #1 reason a lead never even calls.",
    recommendation:
      "Add your summer hours (7am–7pm Mon–Sat) to Google. Takes about two minutes. We can do it for you if you'd rather focus on jobs.",
    impact:
      "Shops that update seasonal hours before demand spikes book on average 3–5 extra service calls in the first two weeks.",
  },
  {
    id: "website",
    tone: "positive",
    icon: "gauge",
    tag: "Website",
    trade: "Roofing",
    title: "Your website is loading faster than 92% of local roofers",
    happened:
      "We checked your homepage speed on Wednesday morning — it loaded in 1.4 seconds on mobile. That's excellent.",
    whyMatters:
      "Fast pages keep folks from bouncing. On mobile, every extra second costs you about 7% of your visitors.",
    recommendation:
      "Nothing to do. You're set. Enjoy the coffee.",
    impact:
      "You're already ahead of the pack here — this is one less thing to worry about.",
  },
  {
    id: "listings",
    tone: "action",
    icon: "list",
    tag: "Directories",
    trade: "Landscaping",
    title: "Two directories have your old phone number",
    happened:
      "Yelp and Bing Places still list your 2023 phone number. Everywhere else is up to date.",
    whyMatters:
      "When a customer calls a wrong number, most don't try a second time. They call whoever ranks below you.",
    recommendation:
      "We noticed this on your behalf. Approve the fix and we'll update both listings within 24 hours.",
    impact:
      "Cleaning up incorrect listings recovers on average 2–4 missed calls per month for a shop your size.",
  },
];

export const healthItems = [
  { id: "reviews", label: "Google Reviews", status: "good", detail: "4.8 stars, 47 reviews. 4 new this week." },
  { id: "ranking", label: "Local Search Ranking", status: "good", detail: "Top 3 for “plumber near me” in your zip." },
  { id: "hours", label: "Business Hours", status: "attention", detail: "Update summer hours on Google." },
  { id: "site-speed", label: "Website Speed", status: "great", detail: "1.4s on mobile — faster than 92% of peers." },
  { id: "listings", label: "Directory Listings", status: "attention", detail: "2 of 14 need a phone number update." },
  { id: "photos", label: "Photos on Google", status: "good", detail: "18 photos uploaded in the last 30 days." },
];
